<template>
  <div class="swap-in-point">
    <v-row>
      <v-col class="text-right">
        <router-link :to="{ name: 'swap-in-point-item-list-create' }"
          class="text-decoration-none ma-2 v-btn v-btn--contained">
          <v-icon>mdi-plus</v-icon>
        </router-link>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="pointList" :items-per-page="-1" :hide-default-footer="true"
      :header-props="{ sortIcon: null }">
      <template v-slot:item.categoryClasses="{ item: { categoryClasses } }">
        {{ getTypeText(categoryClasses) }}
      </template>
      <template v-slot:item.itemLogo="{ item: { itemLogo } }">
        <img :src="itemLogo" />
      </template>
      <template v-slot:item.exchangeRate="{ item }">
        <span @click="handleOpenLogDialog(item)" style="cursor: pointer">
          {{ item.exchangeRate }}
        </span>
        <button @click="handleOpenExchangeRate('', 'exchangeRate', item)">
          <v-icon>mdi-hammer-wrench</v-icon>
        </button>
      </template>
      <template v-slot:item.highestExchangeRate="{ item }">
        <span @click="handleOpenLogDialog(item)" style="cursor: pointer">
          {{ item.highestExchangeRate }}
        </span>
        <button @click="handleOpenExchangeRate('最高', 'highestExchangeRate', item)">
          <v-icon>mdi-hammer-wrench</v-icon>
        </button>
      </template>
      <template v-slot:item.lowestExchangeRate="{ item }">
        <span @click="handleOpenLogDialog(item)" style="cursor: pointer">
          {{ item.lowestExchangeRate }}
        </span>
        <button @click="handleOpenExchangeRate('最低', 'lowestExchangeRate', item)">
          <v-icon>mdi-hammer-wrench</v-icon>
        </button>
      </template>
      <template v-slot:item.edit="{ item }">
        <router-link :to="{ name: 'swap-in-point-item-list-edit', params: { id: item.itemId } }"
          class="text-decoration-none ma-2 v-btn v-btn--contained">
          <v-icon>mdi-lead-pencil</v-icon>
        </router-link>
      </template>
      <template v-slot:item.status="{ item }">
        <v-simple-checkbox @input="handleEditEnable(item)" :value="item.isEnable" />
      </template>
    </v-data-table>
    <Dialog :title="`修改${exchangeRate.itemName}匯率`" :isVisible="isExchangeRateDialogVisible" @ok="handleEditExchangeRate"
      @cancel="handleCloseDialog">
      <v-card-text>
        <h2 style="margin-top: 10px; padding-bottom: 10px">
          目前{{ exchangeRate.name }}匯率: {{ exchangeRate.prevRate }}
        </h2>
        <v-form ref="editForm" v-model="valid">
          <v-text-field type="number" label="修改後匯率" required v-model="exchangeRate.nextRate" :rules="rateRule" />
        </v-form>
      </v-card-text>
    </dialog>
    <Dialog :width="440" title="匯率修改記錄" :isVisible="isLogDialogVisible" @ok="() => { }" @cancel="handleCloseDialog"
      :isHideButton="true">
      <v-data-table :headers="logHeaders" :items="logList" :items-per-page="-1" :hide-default-footer="true"
        :header-props="{ sortIcon: null }">
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.exchangeRate }}</td>
            <td>{{ row.item.createdOn | date }}</td>
            <td>{{ row.item.fullName }}</td>
          </tr>
        </template>
      </v-data-table>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/Dialog.vue';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import Swal from 'sweetalert2';

export default {
  mixins: [ruleMixin],
  components: {
    Dialog,
  },
  data() {
    return {
      valid: true,
      isExchangeRateDialogVisible: false,
      isEnableDialogVisible: false,
      isLogDialogVisible: false,
      dialogInfo: {},
      categoryId: '',
      point: {
        itemName: '',
        itemLogo: '',
        highestExchangeRate: 0,
        exchangeRate: 0,
        lowestExchangeRate: 0,
        categoryClasses: [],
      },
      exchangeRate: {
        itemId: '',
        itemName: '',
        prevRate: '',
        nextRate: '',
      },
      deleteId: '',
      headers: [
        { text: '點數類別', value: 'categoryClasses' },
        { text: '名稱', value: 'itemName' },
        { text: 'Logo', value: 'itemLogo' },
        { text: '目前匯率', value: 'exchangeRate' },
        { text: '最高匯率', value: 'highestExchangeRate' },
        { text: '最低匯率', value: 'lowestExchangeRate' },
        { text: '儲值金', value: 'storedValueBalance' },
        { text: '排序', value: 'sort' },
        { text: '修改', value: 'edit' },
        { text: '啟用', value: 'status' },
      ],
      pointList: [],
      categorySelect: [],
      merchantSelect: [],
      merchantList: [],
      typeManagementList: [],
      logHeaders: [
        { text: '匯率記錄' },
        { text: '修改日期' },
        { text: '修改人員' },
      ],
      logList: [],
      rateRule: this.requiredRule('匯率'),
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getTypeText(list = []) {
      return list.map((item) => item.catName).join('、');
    },
    async getItemList() {
      const { data: { data } } = await api.swapInPoint.itemList();
      this.pointList = data || [];
    },
    handleCloseDialog() {
      this.isExchangeRateDialogVisible = false;
      this.isEnableDialogVisible = false;
      this.isLogDialogVisible = false;
      if (this.$refs.pointForm) {
        this.$refs.pointForm.reset();
        this.$refs.pointForm.resetValidation();
      }
      if (this.$refs.editForm) {
        this.$refs.editForm.reset();
        this.$refs.editForm.resetValidation();
      }
    },
    handleOpenExchangeRate(name, prop, item) {
      this.isExchangeRateDialogVisible = true;
      const rate = item[prop];
      this.exchangeRate = {
        name,
        prop,
        itemId: item.itemId,
        itemName: item.itemName,
        prevRate: rate,
        nextRate: rate,
      };
    },
    async handleEditExchangeRate() {
      if (!this.$refs.editForm.validate()) {
        return;
      }
      const propName = this.exchangeRate.prop.replace(/^\w/, (s) => s.toUpperCase());
      const { status } = await api.swapInPoint[`itemEdit${propName}`](
        this.exchangeRate.itemId,
        this.exchangeRate.nextRate,
      );
      if (status) {
        this.getItemList();
      }
      this.handleCloseDialog();
      this.exchangeRate = {
        itemId: '',
        itemName: '',
        prevRate: '',
        nextRate: '',
      };
    },
    async handleEditEnable(item) {
      const message = item.isEnable ? '停用' : '啟用';
      await Swal.fire(
        {
          title: `您確定要${message}嗎?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        },
      ).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.swapInPoint.itemModifyRateStatus(item.itemId, !item.isEnable);
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: `${message}成功` });
            this.getItemList();
          } else {
            await Swal.fire({ icon: 'warning', title: `${message}失敗，請聯繫系統管理員。` });
          }
        }
      });
    },
    async handleOpenLogDialog({ itemId }) {
      const { data } = await api.swapInPoint.itemLogList(itemId);
      this.logList = data || [];
      this.isLogDialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.swap-in-point {
  table {
    img {
      width: 64px;
      height: auto;
    }
  }

  ::v-deep .v-messages {
    display: none;
  }
}
</style>
